import React, { useEffect, useState } from "react";
import logo from "../../assets/img/globedwiselogo.png";
import { Link } from "react-router-dom";
import { FaPhoneAlt, FaVideo } from "react-icons/fa";

type Props = {};

const MainHeader = (props: Props) => {
  const [showLiveBtn, setShowLiveBtn] = useState(false);
  const currentTime = new Date();
  const currentHour = currentTime.getHours().toString();
  const Sunday = currentTime.getDay().toString();

  useEffect(() => {
    if (currentHour >= "10" && currentHour < "19" && Sunday !== "0") {
      setShowLiveBtn(true);
    } else {
      setShowLiveBtn(false);
    }
  }, []);

  return (
    <div
      className=" d-flex justify-content-between px-4 py-3 align-items-center sticky-top bg-white "
      style={{ height: "4rem", zIndex: 99 }}
    >
      <div className="col-md-4 col-5 p-md-2">
        <Link to="/">
          <img
            src={logo}
            alt=""
            className="w-100"
            style={{ maxWidth: "14rem" }}
          />
        </Link>
      </div>
      <div className="d-flex ">
        <Link
          to="tel:+91 9696875875"
          className="btn btn-sm btn-outline-danger rounded-3 shadow fw-bold me-2"
        >
          <FaPhoneAlt /> +91-9696875875
        </Link>
        <Link
          to="https://globedwise.com/meet"
          target="_blank"
          className="btn blinking-button btn-sm btn-outline-danger rounded-3 shadow "
        >
          <FaVideo /> Meet Us Live!
        </Link>
      </div>
    </div>
  );
};

export default MainHeader;
